import axios from "@/config/axiosConfig";
import { MODULE_IDS } from '@/components/PermissionsContext';
import { getMasterOptions, getAccountMasterOptions } from './master-options-actions';

export const processPurchasePdfData = (files) => {
  return async (dispatch, getState) => {
    try {
        const { auth } = getState();
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("invoices", file);
        });

        const response = await axios.post("/import-pdf/process-purchase-invoices", formData,
            { 
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                params: {
                    userId: auth.user?.id,
                    customerId: auth.customer?.id,
                    companyId: auth.company?.id,
                }
            }
        );
        return response.data;

    } catch (error) {
      console.error(error);
      return { error: error?.messege };
    }
  };
};

export const savePurchasePdfData = (id, data) => {
  return async (dispatch, getState) => {
    try {
        const { auth } = getState();

        const response = await axios.post(`/import-pdf/save-purchase-invoice-draft-by-id/${id}`,
            { data }, 
            { params: { userId: auth.user?.id } }
        );
        return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPurchaseDraftList = () => {
  return async (dispatch, getState) => {
    try {
        const { auth } = getState();

        const response = await axios.get("/import-pdf/get-purchase-drafts", 
            {
                params: {
                    userId: auth.user?.id,
                    customerId: auth.customer?.id,
                    companyId: auth.company?.id,
                }
            }
        );
        return response.data;

    } catch (error) {
      console.error(error);
      return { error: error?.messege };
    }
  };
};

export const deletePurchasePdfData = (id) => {
  return async (dispatch, getState) => {
    try {
        const { auth } = getState();

        const response = await axios.delete(`/import-pdf/delete-purchase-invoice-draft-by-id/${id}`,
            { params: { userId: auth.user?.id } }
        );
        return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};